import { useState, useCallback, useEffect } from 'react';

export const useWaitForNumCalls = (totalNumCalls: number, fn: Function) => {
    const [numCalls, setNumCalls] = useState(0);

    useEffect(() => {
        if (numCalls >= totalNumCalls) {
            fn();
        }
    }, [totalNumCalls, fn, numCalls]);

    const countFn = useCallback(() => setNumCalls((x) => x + 1), []);
    const noop = useCallback(() => {}, []);

    return numCalls < totalNumCalls ? countFn : noop;
};
